import React, { useState } from "react";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { toast } from "react-toastify";
import TimeInput from "./TimeInput";
import { SaveButton, CloseButton } from "../../../common/Buttons";

function CreateProcessDialog({ table, itemData, handleCreateProcess }) {
  const [time, setTime] = useState({ hours: "", minutes: "", seconds: "" });
  const [newProc, setNewProc] = useState({
    proc_name: "",
    batch_size: 1,
  });
  const handleCreate = () => {
    const totalSeconds =
      Number(time.hours) * 3600 +
      Number(time.minutes) * 60 +
      Number(time.seconds);
    if (!newProc.batch_size || newProc.batch_size <= 0) {
      toast.error("배치 사이즈는 1 이상 입력해 주세요.");
      return;
    }
    handleCreateProcess({
      values: {
        proc_name: newProc.proc_name,
        proc_time: totalSeconds,
        batch_size: newProc.batch_size,
      },
      table: table,
    });
  };
  const handleInputChange = (event, field) => {
    let value = event.target.value;
    if (field === "batch_size") {
      if (value <= 0) value = "";
    }
    setNewProc({
      ...newProc,
      [field]: event.target.value,
    });
  };

  return (
    <>
      <DialogTitle variant="h3">공정 추가</DialogTitle>
      <DialogContent
        sx={{ display: "flex", flexDirection: "column", gap: "1.6rem" }}
      >
        <TextField
          label="공정명"
          fullWidth
          required
          value={newProc.proc_name}
          onChange={(e) => handleInputChange(e, "proc_name")}
        />
        <TimeInput time={time} setTime={setTime} />
        <TextField
          label="배치사이즈"
          fullWidth
          required
          type="number"
          value={newProc.batch_size}
          onChange={(e) => handleInputChange(e, "batch_size")}
        />
        {/* 장비 추가하는거 넣도록. 필수 아님.  */}
      </DialogContent>
      <DialogActions>
        <SaveButton onClick={handleCreate} variant="contained" />
        <CloseButton onClick={() => table.setCreatingRow(null)} />
      </DialogActions>
    </>
  );
}

export default CreateProcessDialog;
